var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("global.reports")))]),
      _c("booking-menu"),
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/monthly")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary", "x-large": "" }
                  },
                  [_vm._v("insert_chart")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(" " + _vm._s(_vm.$t("booking.reportMonthly")) + " ")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/organization-unit")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("gamepad")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(
                " " + _vm._s(_vm.$t("booking.reportOrganizationUnit")) + " "
              )
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/domestic-foreign")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("fa-globe")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("div", { staticStyle: { height: "50px" } }, [
              _c("h3", [
                _vm._v(
                  " " + _vm._s(_vm.$t("booking.reportDomesticForeign")) + " "
                )
              ])
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/passenger")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("emoji_people")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(" " + _vm._s(_vm.$t("booking.reportPersons")) + " ")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/airline")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("airplanemode_active")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(" " + _vm._s(_vm.$t("booking.airlineReport")) + " ")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/seat-class")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("airline_seat_recline_extra")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(" " + _vm._s(_vm.$t("booking.bookingClass")) + " ")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "pa-4 text-md-center elevation-5 ma-4 report-buttons",
            on: {
              click: function($event) {
                return _vm.$router.push("/booking/report/budget")
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { "padding-left": "45px" } },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: { "font-size": "60px" },
                    attrs: { color: "primary" }
                  },
                  [_vm._v("attach_money")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "plus-button",
                    attrs: { color: "success", "x-small": "", fab: "" }
                  },
                  [_c("v-icon", [_vm._v("fa-plus")])],
                  1
                )
              ],
              1
            ),
            _c("h3", [
              _vm._v(" " + _vm._s(_vm.$t("booking.budgetUtilization")) + " ")
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }